module.exports = __webpack_public_path__ + "static/media/error.5cc9e75d.svg";